import TooltipModalBody from "ds/components/TooltipModal/Body";
import { TooltipModalTitle } from "ds/components/TooltipModal/Title";
import Typography from "ds/components/Typography";

const AssignRoleFormTooltipInfo = () => {
  return (
    <>
      <TooltipModalTitle>Roles</TooltipModalTitle>
      <TooltipModalBody align="start">
        <Typography tag="p" variant="p-body3">
          You can assign multiple roles to a single entity within the same space.
          <br />
          <br />
          To use custom roles, your role must have at least the <strong>Read system role</strong> as
          a minimum permissions baseline.
          <br />
          <br />
          You can also leverage the Write system role as a baseline and add other permissions as
          well, if you need something that is more powerful than Write, but less powerful than
          Admin.
        </Typography>

        {/* TODO: enable when docs are ready */}
        {/* <ReadMoreDocsLink docsUrl={getDocsUrl("/concepts/roles/")} /> */}
      </TooltipModalBody>
    </>
  );
};

export default AssignRoleFormTooltipInfo;
